import { DestroyRef, Directive, inject, InjectionToken, Input, OnInit, signal, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, Subject, Subscription } from 'rxjs';
import { LOG } from '../../common/util/log';
import { ChartBinding } from './chart-controller.directive';
import { ChartTimeframe, ChartTimeframes, ChartTimeframeSelector } from './chart-timeframe-selector';
import { SelectedTimeframe } from './selected-timeframe';

export const CHART_ZOOM: InjectionToken<Subject<[Highcharts.Axis, Highcharts.AxisSetExtremesEventObject]>> = new InjectionToken('chart zoom');
export const CURRENT_CHART_TIMEFRAME: InjectionToken<WritableSignal<ChartTimeframe | null>> = new InjectionToken('chart timeframe');

@Directive({
  selector: '[chartTimeframeController]',
  standalone: true,
  providers: [{
    provide: CURRENT_CHART_TIMEFRAME,
    useFactory: () => signal(null),
  },
  {
    provide: ChartTimeframeSelector,
    useFactory: () => new ChartTimeframeSelector(),
  },

]
})
export class ChartTimeframeControllerDirective implements OnInit {
  @Input({ required: false }) public set timesframes(value: ChartTimeframes) {
    if (value) {
      if (!this.controller) LOG.error('Controller is null', this);
      else this.controller.timesframes = value;
    }
  }

  public readonly controller: ChartTimeframeSelector = inject(ChartTimeframeSelector);

  private readonly chartBinding = inject(ChartBinding);
  private readonly destroyRef = inject(DestroyRef);

  private selectionChangedSubscription: Subscription | undefined;
  private rangeChangedSubscription: Subscription | undefined;

  @Input({ alias: 'chartTimeframeSelector', required: true }) public set selectionChanged$(value: Observable<SelectedTimeframe>) {
    if (this.selectionChangedSubscription) {
      this.selectionChangedSubscription.unsubscribe();
    }

    this.selectionChangedSubscription =  value.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(selection => this.controller?.updateSelection(selection));
  }

  @Input({ alias: 'chartTimeRanges', required: false }) public set rangeChanged$(value: Observable<ChartTimeframe>) {
    if (this.rangeChangedSubscription) {
      this.rangeChangedSubscription.unsubscribe();
    }

    this.rangeChangedSubscription =  value.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(range => this.controller?.updateRange(range));
  }

  ngOnInit(): void {
    if (this.chartBinding) {
      this.controller.initialize(this.chartBinding);
    }
  }
}
